/* ============================================================================
   PLP_003 — mobile slider for the full-width info lines in the product grid.

   `<plp003-slider>` is a custom element, so it re-initialises itself for free
   every time facets.js replaces #ProductGridContainer.innerHTML on filter /
   sort / paginate.

   Swiper is fetched from the CDN on demand and only when BOTH are true:
     - <body> carries the `test-plp-003` reveal class (Intelligems may add it
       after the document has parsed, so the class is observed, not just read)
     - the viewport is below the theme's 768px desktop breakpoint
   Control traffic and desktop traffic therefore pay zero extra requests. Until
   Swiper is ready the track is a native scroll-snap carousel (see the CSS), so
   the line is swipeable even if the CDN never answers.
   ========================================================================== */
(function () {
  'use strict';

  var BODY_CLASS = 'test-plp-003';
  var SWIPER_SRC = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  var MOBILE_QUERY = '(max-width: 767.98px)';

  var sliders = new Set();
  var swiperPromise = null;

  function loadSwiper() {
    if (window.Swiper) return Promise.resolve(window.Swiper);
    if (!swiperPromise) {
      swiperPromise = new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = SWIPER_SRC;
        script.async = true;
        script.onload = function () {
          resolve(window.Swiper);
        };
        script.onerror = function () {
          swiperPromise = null;
          reject(new Error('PLP_003: Swiper failed to load'));
        };
        document.head.appendChild(script);
      });
    }
    return swiperPromise;
  }

  var mql = window.matchMedia(MOBILE_QUERY);

  function isRevealed() {
    return !!document.body && document.body.classList.contains(BODY_CLASS);
  }

  function syncAll() {
    sliders.forEach(function (slider) {
      slider.sync();
    });
  }

  if (mql.addEventListener) {
    mql.addEventListener('change', syncAll);
  } else if (mql.addListener) {
    mql.addListener(syncAll);
  }

  function watchBodyClass() {
    new MutationObserver(syncAll).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.body) {
    watchBodyClass();
  } else {
    document.addEventListener('DOMContentLoaded', watchBodyClass);
  }

  class Plp003Slider extends HTMLElement {
    connectedCallback() {
      sliders.add(this);
      this.sync();
    }

    disconnectedCallback() {
      sliders.delete(this);
      this.teardown();
    }

    sync() {
      if (isRevealed() && mql.matches) {
        this.setup();
      } else {
        this.teardown();
      }
    }

    setup() {
      if (this.swiper || this.pending) return;
      var track = this.querySelector('.plp003-swiper');
      if (!track) return;
      var dots = this.querySelector('.plp003-dots');
      var self = this;
      this.pending = true;
      loadSwiper()
        .then(function (Swiper) {
          self.pending = false;
          // Conditions may have changed while the library was in flight.
          if (self.swiper || !self.isConnected || !isRevealed() || !mql.matches) return;
          self.swiper = new Swiper(track, {
            slidesPerView: 1,
            spaceBetween: 12,
            autoHeight: true,
            watchOverflow: true,
            a11y: { enabled: false },
            pagination: dots ? { el: dots, clickable: true } : false
          });
        })
        .catch(function () {
          self.pending = false;
        });
    }

    teardown() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  if (!customElements.get('plp003-slider')) {
    customElements.define('plp003-slider', Plp003Slider);
  }
})();
